import dynamic from "next/dynamic";
import { Props } from "./QRCode";

export default dynamic<Props>(() => import("./QRCode"), { ssr: false });
